import { Plugins } from '@leverege/plugin';
import CoownerId from "./CoownerId.js";
import CreatedAt from "./CreatedAt.js";
import OwnerId from "./OwnerId.js";
import Path from "./Path.js";
import Type from "./Type.js";
import UpdatedAt from "./UpdatedAt.js";
import Name from "./Name.js";
import RsrcFlagsAttribute from "./RsrcFlagsAttribute.js";
import Url from "./Url.js";
function install(plg = Plugins) {
  plg.addPlugin('Attribute', CoownerId);
  plg.addPlugin('Attribute', OwnerId);
  plg.addPlugin('Attribute', Path);
  plg.addPlugin('Attribute', Type);
  plg.addPlugin('Attribute', CreatedAt);
  plg.addPlugin('Attribute', UpdatedAt);
  plg.addPlugin('Attribute', Name);
  plg.addPlugin('Attribute', RsrcFlagsAttribute);
  plg.addPlugin('Attribute', Url);
  // plg.addPlugin( 'AttributeValueRenderer', RsrcFlagsRendererPlg )
}
export default {
  install
};